import { actionTypes } from '../../../types';

export const getInfluencerProfileRequest = (payload) => ({
    type: actionTypes.GET_INFLUENCER_PROFILE_REQUEST,
    payload,
});

export const getInfluencerProfileSuccess = (payload) => ({
    type: actionTypes.GET_INFLUENCER_PROFILE_SUCCESS,
    payload,
});

export const getInfluencerProfileFailure = (payload) => ({
    type: actionTypes.GET_INFLUENCER_PROFILE_FAILURE,
    payload,
});

export const getInfluencerProfileReset = () => ({
    type: actionTypes.GET_INFLUENCER_PROFILE_RESET,
});

export const getInfluencerProfileResetAll = () => ({
    type: actionTypes.GET_INFLUENCER_PROFILE_RESET_ALL,
});
